<template>
  <Row type="flex" :gutter="20" align="middle" style="padding:8px 0">
    <i-col offset="2" :span="2">
      <!-- <Checkbox v-if="!hideCheck" v-model="isChecked"/> -->
    </i-col>
    <i-col v-if="field.slug !== 'about_me' && field.type !== 'array'" :span="6" class="section-label m">
      <span v-if="field.slug === 'generic_id' && $store.state.user.brand.generic_id" class="section-label m" style="margin-top: 0;">
        {{field.slug == "generic_id" ? $store.state.user.brand.generic_id.label : field.label}}
      </span>
      <span v-else class="section-label m" style="margin-top: 0;">
        {{field.slug == "first_name" ? "Full Name" : field.label}}
      </span>
    </i-col>
    <i-col :span="(field.slug === 'about_me' || field.type === 'array') ? 19:13">
      <div v-if="isFieldSelectionString(field.slug) && (field.type === 'string' || field.type === 'int')">
        <i-input :style="tooltip ? 'padding-right:20px' : ''" v-model="profile[field.slug]" @on-change="onChange(field.slug)"></i-input></div>
      <div v-if="(field.slug =='region'||field.slug =='province') && field.type === 'string'">
        <select v-on:change="onChange(field.slug)" v-model="profile[field.slug]" filterable ref="selectField" class="ivu-select-selection custom-ui-select">
          <option v-for="(item, index) in sortedSelections" :key="index" @click="profile[field.slug] = item.name">{{ item.name }}</option>
        </select>
      </div>
      <div v-if="(field.slug =='country') && field.type === 'string'">
        <select v-on:change="onChange(field.slug)" v-model="profile[field.slug]" filterable ref="selectField" class="ivu-select-selection custom-ui-select">
          <option v-for="(item, index) in sortedCountries" :key="index" @click="profile[field.slug] = item.country_name">{{ item.country_name }}</option>
        </select>
      </div>
      <div v-if="field.slug =='contact_number' && field.type === 'string'">
        <TelInputLg v-model="profile[field.slug]" @onTelInput="onTelInput"
            placeholder="Enter your mobile no." ref="telInput" class="flag-only"></TelInputLg>
      </div>
      <div v-if="field.slug == 'about_me' && field.type == 'string'">
        <i-input @on-change="onChange(field.slug)" v-model="profile[field.slug]" type="textarea" :rows="4"></i-input></div>
      <div v-if="field.type === 'enum' && field.slug !== 'province' && field.slug !== 'region'">
        <RadioGroup v-model="profile[field.slug]" @on-change="onChange(field.slug)">
          <Radio style="width:100px;display:block"
            v-for="(i, indx) in field.options" :key="indx"
            :label="i.value">{{i.label}}</Radio>
        </RadioGroup>
      </div>
      <div v-if="field.type == 'array'">
        <div v-if="array && array.length > 0">
          <draggable :lisadwat="array" @start="drag=true" @end="drag=false" @change="onArrayChangePosition">
            <div v-for="(item, indx) in array" :key="indx" style="cursor:move">
              <Row :gutter="25">
                <i-col :span="22">
                  <i-input style="margin-bottom:5px;" @on-change="onChange(field.slug, indx)" v-model="array[indx]['name']"></i-input>
                </i-col>
                <i-col style="padding-right:0px;padding-left:0px;cursor:default" :span="2">
                  <Icon v-if="array.length - 1 != indx" @click='removeArray(indx)' type="minus-circled" style='margin-top:9px;'></Icon>
                </i-col>
              </Row>
            </div>
          </draggable>
        </div>
      </div>
      <!-- <Button @click='addEmpty(field.slug)' size="small" v-if="field.type == 'array'" style="float:right;margin-right:9%">Add</Button> -->
      <span v-if='tooltip' class='tooltip' style="position:absolute;top:0px;right:5px;line-height:32px">
        <Tooltip :placement="tooltipPosition">
          <Icon type="information-circled"></Icon>
          <div slot="content">
            <div v-for="(tooltip, i) in tooltipArray" :key='i'>
              <p><span v-html="tooltip"></span></p>
            </div>
          </div>
        </Tooltip>
      </span>
    </i-col>
  </Row>
</template>

<script>
  import { TelInputLg } from '@/helpers/tel-input';
  import countriesJson from '@/assets/list_country.json'
  import regions from '@/helpers/ph-info/regions.json'
  import provinces from '@/helpers/ph-info/provinces.json'
  import draggable from 'vuedraggable';
  import _ from 'lodash'

  export default {
    data() {
      return {
        regions,
        provinces,
        array: []
      }
    },
    components: {
      TelInputLg,
      draggable
    },
    props: {
      hideCheck: {
        type: Boolean
      },
      field: {
        type: Object
      },
      profile: {
        type: Object
      },
      tooltip: {
        type: String
      },
      tooltipPosition: {
        type: String
      }
    },
    computed: {
      sortedCountries() {
        return countriesJson.sort(function (a, b) {
            return ('' + a.country_name).localeCompare(b.country_name);
        })
      },
      sortedSelections() {
        if( this.field.slug === 'region' )
          return this.regions
        if( this.field.slug === 'province' )
          return this.provinces.sort(function (a, b) {
              return ('' + a.name).localeCompare(b.name);
          })
        else
          return []
      },
      isChecked: {
        get() {
          if(!this.profile['visible_fields'] || this.profile['visible_fields'] === null)
            return false;
          return (this.profile['visible_fields'].indexOf(this.field.slug) > -1)
        },
        set(v) {
          BroadcastEvent.$emit('ONFIELDCHANGE', 'visible_fields')

          if( this.profile['visible_fields']  === null )
            this.profile['visible_fields'] = []

          if (this.profile['visible_fields'].length <= 0) {
            this.profile['visible_fields'].push(this.field.slug)
            return false;
          }

          var indx = this.profile['visible_fields'].indexOf(this.field.slug)
          var exist = (indx > -1);

          if (!exist)
            this.profile['visible_fields'].push(this.field.slug)
          else
            this.profile['visible_fields'].splice(indx, 1)
        }
      },
      tooltipArray() {
        if(this.tooltip) {
          return this.tooltip.split('\n')
        }
      }
    },
    methods: {
      getRegionKey() {
        return searchArrayValue(this.form.region, this.regions)
      },
      onTelInput(res) {
        if (res.isValid) {
          BroadcastEvent.$emit('ONFIELDCHANGE', 'contact_number')
          this.onUpdate(res.number)
        }
      },
      isFieldSelectionString(s) {
        return (s== 'contact_number' || s == 'about_me' || s == 'province' || s == 'country' || s == 'region') ? false : true
      },
      isInSlug(s) {
        return (this.slug.indexOf(s) > -1)
      },
      onChange(slug, indx) {
        if(this.field.type == 'array') {
          this.profile[slug] = this.array.filter(n => n.name).map((n, i) => {
            n.order = i + 1
            return n
          })
          if(this.array.length - 1 == indx) {
            this.addEmpty(slug)
          }
          if(this.array.length - 2 == indx && this.array[indx].name == '') {
            this.removeArray(indx)
          }
        }

        BroadcastEvent.$emit('ONFIELDCHANGE', slug)
      },
      addEmpty(slug) {
        if(this.array && this.array.length > 0) {
          this.array.push({"name": ""})
        } else {
          this.array = [{"name": ""}]
        }
      },
      removeArray(index) {
        if(this.array[index]) {
          this.array.splice(index, 1)
          this.onChange(this.field.slug)
        } else {
          this.array.splice(index, 1)
        }
      },
      onArrayChangePosition(event) {
        if (event.moved) this.onChange(this.field.slug)
      }
    },
    mounted() {
      let slug = this.field.slug
      if(this.field.type == 'array') {
        this.array = this.profile[slug]
        if(!this.array) {
          this.array = [{"name": ""}]
        } else if(this.array.length == 0) {
          this.array = [{"name": ""}]
        } else if(this.array.constructor != Array) {
          this.array = [{"name": ""}]
        } else if(this.array && this.array[0] && this.array[0].constructor == String) {
          var newArray = []
          this.array.forEach(item => {
            newArray.push({"name": item})
          })
          if(this.newArray && this.newArray.length == 0) {
            this.newArray = [{"name": ""}]
          }
          this.array = newArray
        }

        if(this.array[this.array.length - 1].name != '') {
          this.addEmpty(slug)
        }
      }
    }
  }
</script>

<style scoped>
  .section-label {
    font-size:11px;
    line-height: 20px;
    color:#aaa;
  }
  .m {
    color: #333
  }
</style>
